import React from "react";
import "./social_sharing.scss";
import {
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton
} from "react-share";
import {CopyToClipboard} from "react-copy-to-clipboard";
import ctc from '../../assets/ctclipboard.png';
import openEmail from '../../assets/openEmail.png';
import {ReactComponent as TwitterLogo} from "../../assets/social_media_icons/twitter.svg";
import TemplateComponent from "../../containers/template_page/template_component/template_component";


class SocialSharing extends TemplateComponent {

    onCopy = () => {
        this.setState({message: true, copied: true});
        setTimeout(() => {this.setState({message: false, copied: false})}, 1000);
    };


    componentRender(data) {
        //get title page from component page
        //var elem_title = document.getElementsByClassName("top-title");
        //quote={(elem_title) ? document.title +' - '+ elem_title[0].innerText : document.title }

        const commonProps = {fill: 'transparent'};
        return(
            <div className="c67-container-social auto-margins">
                <ul>
                    <li>
                        <span className={'title'}>Share:</span>
                    </li>
                    <li>
                        <FacebookShareButton
                            url={window.location.href}
                            quote={document.title}
                            className="Demo__some-network__share-button">
                            <FacebookIcon size={44} logoFillColor={'#003a70'}
                                          iconBgStyle={commonProps}/>
                        </FacebookShareButton>
                    </li>
                    <li  style={{justifyContent: "center"}} >  
                        <TwitterShareButton
                            url={window.location.href} className="Demo__some-network__share-button">


                            <TwitterLogo width="22" height="22" fill={'#003a70'} 
                                        />
                        </TwitterShareButton>
                    </li>
                    <li>
                        <CopyToClipboard onCopy={this.onCopy}
                                         text={window.location.href}>
                            <img src={ctc} alt="Luiss.it"
                                 className="social-share-ctc"/>
                        </CopyToClipboard>
                        <span className={this.state.copied && this.state.message ? "copied-message show" : "copied-message hide"}>Link Copiato</span>
                    </li>
                    <li>
                        <EmailShareButton
                            url={window.location.href}
                            subject={'Le ultime news'}
                            className="Demo__some-network__share-button">
                            <img src={openEmail} alt="Luiss.it"
                                 className="social-share-email"/>
                        </EmailShareButton>
                    </li>
                </ul>
            </div>
        );
    }

}


export default SocialSharing;

